<template>
  
  <div class="inspection-container">
    <Loading v-if="loading" />
    <div class="select-container">
      <b-select placeholder="Jump to" expanded v-model.trim="selected">
        <option
          v-for="options in inspectionData.filter(
            (cat) => cat.conditions.length > 0
          )"
          :key="options.title"
        >
          {{ options.title }}
        </option>
      </b-select>
    </div>

    <div v-if="selected">
      <div class="card-title">
        <h3>{{ selected }}</h3>
      </div>
      <div v-for="data in inspectionData" :key="data.title">
        <div v-if="data.title === selected" class="details-container">
          <div class="details">
            <li v-for="condition in data.conditions" :key="condition.feature">
              <div class="list-content">
                <strong>{{ condition.feature }}</strong>

                <div
                  v-if="!(condition.feature === 'Paint Meter Readings')"
                  class="checklist-container"
                >
                  <b-field>
                    <b-radio-button
                      type="is-primary"
                      value="Yes"
                      :name="condition.feature"
                      v-model="condition.inspectorResponse"
                      native-value="Yes"
                    >
                      <span>Yes</span>
                    </b-radio-button>

                    <b-radio-button
                      type="is-primary"
                      value="No"
                      :name="condition.feature"
                      v-model="condition.inspectorResponse"
                      native-value="No"
                    >
                      <span>No</span>
                    </b-radio-button>
                  </b-field>
                </div>
              </div>
              <div
                class="inputs-container"
                v-if="condition.feature === 'Paint Meter Readings'"
              >
                <div>
                  <span>Low Value</span>
                  <input
                    v-model="condition.lowValue"
                    type="text"
                  />
                </div>
                <div>
                  <span>High Value</span>
                  <input
                    v-model="condition.highValue"
                    type="text"
                  />
                </div>
              </div>
              <div
                v-if="condition.inspectorResponse === 'Yes'"
                class="comment-section"
              >
                <input
                  v-model="condition.inspectorComment"
                  placeholder="Enter your comment here"
                  type="text"
                />
              </div>
            </li>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { GET } from "../api";
import Loading from './Loading'

export default {
  name: "Inspection",
  data() {
    return {
      selected: "Exterior",
      inspectorResponse: {},
      inspectorComments: {},
      inspectionData: [],
      loading: false
    };
  },
  props: {
    vehicle: Object,
  },

  computed: {
    filledInspectionForm() {
      if (this.inspectionData.length) {
        return this.inspectionData.map((category) => {
          const hasComment =
            category.conditions.filter(
              (condition) => condition.inspectorComment
            ).length > 0;
          return { ...category, hasComment };
        });
      }
    },
  },
  methods: {
    bbFeature2InspectionFeature(bbOption) {
      return {
        feature: bbOption.name,
        inspectorResponse: "",
        inspectorComment: undefined,
        _bbFeature: bbOption,
      };
    },
  },
  async beforeCreate() {
    this.loading = true;
    const vehicleRes = await GET(`vehicles/${this.$route.params.id}`);

    if (vehicleRes.data.inspectionData) {
      this.loading = false;
      return (this.inspectionData = vehicleRes.data.inspectionData);
    }

    this.loading = false;
    return (this.inspectionData = [
      {
        title: "Exterior",
        hasComment: null,
        conditions: [
          {
            feature: "Minor Body Damage",
            inspectorResponse: "",
            inspectorComment: "",

            inspectorCanComment: true,
          },
          {
            feature: "Moderate Body Damage",
            inspectorResponse: "",
            inspectorComment: "",
            inspectorCanComment: true,
          },
          {
            feature: "Major Body Damage",
            inspectorResponse: "",
            inspectorComment: "",
            inspectorCanComment: true,
          },
          {
            feature: "Scratches",
            inspectorResponse: " ",
            inspectorComment: "",
          },
          {
            feature: "Glass Damaged/Cracked",
            inspectorResponse: "",
            inspectorComment: "",
          },
          {
            feature: "Lights Damaged/Cracked",
            inspectorResponse: "",
            inspectorComment: "",
          },
          {
            feature: "Minor Body Rust",
            inspectorResponse: "",
            inspectorComment: "",
          },
          {
            feature: "Moderate Body Rust",
            inspectorResponse: "",
            inspectorComment: "",
          },
          {
            feature: "Major Body Rust",
            inspectorResponse: "",
            inspectorComment: "",
          },
          {
            feature: "Hail Damage",
            inspectorResponse: "",
            inspectorComment: "",
          },
          {
            feature: "Aftermarket Parts - Exterior",
            inspectorResponse: "",
            inspectorComment: "",
          },
          {
            feature: "Mismatched Paint Colors",
            inspectorResponse: "",
            inspectorComment: "",
          },
          {
            feature: "Paint Meter Readings",
            inspectorResponse: "",
            inspectorComment: "",
            lowValue: "",
            highValue: ""
          },
        ],
      },
      {
        hasComment: false,
        title: "Mechanical",
        conditions: [
          {
            feature: "Jump Start Required",
            inspectorResponse: "",
            inspectorComment: "",
          },
          {
            feature: "Engine Problem: Engine Does Not Crank",
            inspectorResponse: "",
            inspectorComment: "",
          },
          {
            feature: "Engine Cranks, Does Not Start",
            inspectorResponse: "",
            inspectorComment: "",
          },
          {
            feature: "Engine Problem: Engine Does Not Stay Running",
            inspectorResponse: "",
            inspectorComment: "",
          },
          {
            feature: "Engine Problem: Internal Engine Noise",
            inspectorResponse: "",
            inspectorComment: "",
          },
          {
            feature: "Engine Problem: Runs Rough/Hesitation",
            inspectorResponse: "",
            inspectorComment: "",
          },
          {
            feature: "Engine Problem: Timing Chain/Camshaft Issue",
            inspectorResponse: "",
            inspectorComment: "",
          },
          {
            feature: "Engine Problem: Excessive Smoke from Exhaust",
            inspectorResponse: "",
            inspectorComment: "",
          },
          {
            feature: "Engine Problem: Head Gasket Issue",
            inspectorResponse: "",
            inspectorComment: "",
          },
          {
            feature: "Excessive Exhaust Noise",
            inspectorResponse: "",
            inspectorComment: "",
          },
          {
            feature: "Exhaust Modification's",
            inspectorResponse: "",
            inspectorComment: "",
          },
          {
            feature: "Emissions Modifications",
            inspectorResponse: "",
            inspectorComment: "",
          },
          {
            feature: "Catalytic Converters Missing",
            inspectorResponse: ", ",
            inspectorComment: "",
          },
          {
            feature: "Aftermarket Parts - Mechanical",
            inspectorResponse: ", ",
            inspectorComment: "",
          },
          {
            feature: "Engine Accessory Issue",
            inspectorResponse: "",
            inspectorComment: "",
          },
          {
            feature: "Actively Dripping Oil Leak",
            inspectorResponse: "",
            inspectorComment: "",
          },
          {
            feature: "Engine Problem: Oil/Coolant Intermix on Dipstick",
            inspectorResponse: ", ",
            inspectorComment: "",
          },
        ],
      },
      {
        hasComment: false,
        title: "Frame",
        conditions: [
          {
            feature: "Frame/Unibody Damage",
            inspectorResponse: "",
            inspectorComment: "",
          },
          {
            feature: "Undercarriage Surface Rust",
            inspectorResponse: "",
            inspectorComment: "",
          },
          {
            feature: "Undercarriage Heavy Rust",
            inspectorResponse: "",
            inspectorComment: "",
          },
          {
            feature: "Penetrating Rust",
            inspectorResponse: "",
            inspectorComment: "",
          },
        ],
      },
      {
        hasComment: false,
        title: "Warning Lights",
        conditions: [
          {
            feature: "Check Engine Light",
            inspectorResponse: "",
            inspectorComment: "",
          },
          {
            feature: "Airbag Light",
            inspectorResponse: "",
            inspectorComment: "",
          },
          {
            feature: "Brake/ABS Light",
            inspectorResponse: "",
            inspectorComment: "",
          },
          {
            feature: "Traction Control Light",
            inspectorResponse: "",
            inspectorComment: "",
          },
          {
            feature: "TPMS Light",
            inspectorResponse: "",
            inspectorComment: "",
          },
          {
            feature: "Battery/Charging Light",
            inspectorResponse: "",
            inspectorComment: "",
          },
          {
            feature: "Other Warning Light",
            inspectorResponse: "",
            inspectorComment: "",
          },
          {
            feature: "OBDII Codes",
            inspectorResponse: "",
            inspectorComment: "",
          },
          {
            feature: "Incomplete Readiness Monitors",
            inspectorResponse: ", ",
            inspectorComment: "",
          },
        ],
      },
      {
        hasComment: false,
        title: "Wheels & Tires",
        conditions: [
          {
            feature: "Aftermarket Rims / Tires",
            inspectorResponse: "",
            inspectorComment: "",
          },
          {
            feature: "Damaged Wheels",
            inspectorResponse: "",
            inspectorComment: "",
          },
          {
            feature: "Incorrectly Sized Tires",
            inspectorResponse: "",
            inspectorComment: "",
          },
          {
            feature: "Damaged Tires",
            inspectorResponse: "",
            inspectorComment: "",
          },
          {
            feature: "Uneven Tread Wear",
            inspectorResponse: "",
            inspectorComment: "",
          },
          {
            feature: "Mismatched Tires",
            inspectorResponse: "",
            inspectorComment: "",
          },
          {
            feature: "Missing Spare Tire and / or Equipment",
            inspectorResponse: "",
            inspectorComment: "",
          },
          {
            feature: "Tire Measurements",
            inspectorResponse: "",
            inspectorComment: "",
          },
          {
            feature: "Front Driver",
            inspectorResponse: "",
            inspectorComment: "",
          },
          {
            feature: "Front Passenger",
            inspectorResponse: "",
            inspectorComment: "",
          },
          {
            feature: "Rear Passenger",
            inspectorResponse: "",
            inspectorComment: "",
          },
          {
            feature: "Rear Driver",
            inspectorResponse: "",
            inspectorComment: "",
          },
        ],
      },
      {
        hasComment: false,
        title: "Interior",
        conditions: [
          {
            feature: "Seat DamageWear",
            inspectorResponse: "",
            inspectorComment: "",
          },
          {
            feature: "Carpet Damage",
            inspectorResponse: "",
            inspectorComment: "",
          },
          {
            feature: "Dashboard Damage",
            inspectorResponse: "",
            inspectorComment: "",
          },
          {
            feature: "Headliner Damage",
            inspectorResponse: "",
            inspectorComment: "",
          },
          {
            feature: "Interior Trim Damage",
            inspectorResponse: "",
            inspectorComment: "",
          },
          {
            feature: "Interior Odor",
            inspectorResponse: "",
            inspectorComment: "",
          },
          {
            feature: "Crank Windows",
            inspectorResponse: "",
            inspectorComment: "",
          },
          {
            feature: "Not Equipped with Factory A/C",
            inspectorResponse: "",
            inspectorComment: "",
          },
          {
            feature: "Electronics Issue",
            inspectorResponse: "",
            inspectorComment: "",
          },
          {
            feature: "Five Digit Odometer",
            inspectorResponse: "",
            inspectorComment: "",
          },
          {
            feature: "SunroofFactory operational",
            inspectorResponse: "",
            inspectorComment: "",
          },
          {
            feature: "Navigation",
            inspectorResponse: "",
            inspectorComment: "",
          },
          {
            feature: "Aftermarket Stereo Equipment",
            inspectorResponse: "",
            inspectorComment: "",
          },
          {
            feature: "Airbag Deployed",
            inspectorResponse: "",
            inspectorComment: "",
          },
          {
            feature: "HVAC Not Working",
            inspectorResponse: "",
            inspectorComment: "",
          },
          {
            feature: "Leather or Leather Type Seats",
            inspectorResponse: "",
            inspectorComment: "",
          },
        ],
      },
      {
        hasComment: false,
        title: "Options",
        conditions: this.vehicle.bbFeatures.map(
          this.bbFeature2InspectionFeature
        ),
      },
      {
        hasComment: false,
        title: "Drivability",
        conditions: [
          {
            feature: "Vehicle INOP (Does Not Move)",
            inspectorResponse: "",
            inspectorComment: "",
          },
          {
            feature: "Transmission Issue",
            inspectorResponse: "",
            inspectorComment: "",
          },
          {
            feature: "4x4 / 4WD / Drivetrain Issue",
            inspectorResponse: "",
            inspectorComment: "",
          },
          {
            feature: "Steering Issue",
            inspectorResponse: "",
            inspectorComment: "",
          },
          {
            feature: "Brake Issue",
            inspectorResponse: "",
            inspectorComment: "",
          },
          {
            feature: "Suspension Issue",
            inspectorResponse: "",
            inspectorComment: "",
          },
          {
            feature: "Suspension Modifications",
            inspectorResponse: "",
            inspectorComment: "",
          },
        ],
      },
      {
        hasComment: false,
        title: "Title & History",
        conditions: [
          {
            feature: "Title Absent (30 Days)",
            inspectorResponse: "",
            inspectorComment: "",
          },
          {
            feature: "Branded Title",
            inspectorResponse: "",
            inspectorComment: "",
          },
          {
            feature: "True Mileage Unknown/Not Actual Miles",
            inspectorResponse: "",
            inspectorComment: "",
          },
          {
            feature: "Off Lease Vehicle",
            inspectorResponse: "",
            inspectorComment: "",
          },
          {
            feature: "Repair Order Attached",
            inspectorResponse: "",
            inspectorComment: "",
          },
          {
            feature: "Repossession Papers",
            inspectorResponse: "",
            inspectorComment: "",
          },
          {
            feature: "Mobility",
            inspectorResponse: "",
            inspectorComment: "",
          },
        ],
      },
    ]);
  },
  watch: {
    filledInspectionForm: {
      deep: true,
      handler() {
        this.$emit("dataChanged", this.filledInspectionForm);
      },
    },
  },
};
</script>

<style lang="postcss">
.inspection-container {
  width: 100%;
  background: #f5f5f5;

  & .list-content {
    flex-direction: column;

    & .b-radio.radio.button {
      border-radius: 4px !important;
    }
  }

  & .select-container {
    width: 100%;
    margin-bottom: 30px;
  }

  & .inputs-container {
    display: flex;
    margin-top: 10px;
    justify-content: space-around;
    & input {
      margin-left: 5px;
      max-width: 60px;
      padding: 5px;
      border-radius: 4px;
      border: 1px solid rgba(0, 0, 0, 0.21961);
    }
  }
}
</style>